import { transparentPng } from '../utils/constants';

export default (state = { tempPhotoUrl: null }, action) => {
    switch (action.type) {
        case 'UPLOAD:TEMP_PHOTO':
            return {
                ...state,
                loading: true,
                tempPhotoUrl: action.usePng ? transparentPng : null,
            };
        case 'UPLOAD:TEMP_PHOTO_SUCCESS':
            return {
                tempPhotoUrl: action.res.data.path,
                loading: false,
            };
        case 'UPLOAD:CLEAR_TEMP_PHOTO':
            return {
                ...state,
                tempPhotoUrl: action.usePng ? transparentPng : null,
            };
        default:
            return state;
    }
};
